import {Footer} from "../Footer";
import {Header} from "../Header";
import {Helmet} from "react-helmet";

export const TermsAndConditionsPage = () => {
  
  return (
    <div className="container">
      <Helmet>
        <title>Sklep AGD - Regulamin</title>
      </Helmet>
    <Header />  
      
    <main className="mt-4">
      <h2>Regulamin</h2>
      <p className="my-4">
        W prawdziwym sklepie znajdziesz tutaj jego regulamin, ale tutaj nic nie ma bo to tylko sklep testowy.    
      </p>
    </main>
      
    <Footer />
      
  </div>
  );
  
}